import {Component, ElementRef, OnInit, ViewChild, Input} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataService} from '../../../services/data.service';
import {ManageReportService} from '../../../services/manage-report.service';
import {InfoModalComponent} from '../info-modal/info-modal.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-merge-report',
  templateUrl: './merge-report.component.html',
  styleUrls: ['./merge-report.component.scss']
})
export class MergeReportComponent implements OnInit {
  private formData = new FormData();
  public mode:string = "view";
  public checkedImgs = [];
  public isMerging:boolean = false;
  public overLimit:boolean = false;

  public reportsData;
  
  @ViewChild('file', {static: false}) public file: ElementRef;

  mergeReportForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private service: DataService,
    private reportService: ManageReportService,
    private modalService: NgbModal,
    public fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.mergeReportForm = this.fb.group({
      mergeDescription: ['', [Validators.required]],
      mergeTransport: ['', [Validators.required]],
      mergeCategory: ['', [Validators.required]],
    });
  }

  merge() {

    if ( this.checkedImgs.length > 3 ) {
      this.overLimit = true;
      return;
    }

    this.isMerging = true;
    this.overLimit = false;
    
    const
      description = this.reportsData.description[parseInt(this.mergeReportForm.get('mergeDescription').value) || 0],
      transportMode = this.reportsData.transport[parseInt(this.mergeReportForm.get('mergeTransport').value) || 0],
      chosenCategory = this.reportsData.category[parseInt(this.mergeReportForm.get('mergeCategory').value) || 0],
      category = chosenCategory ? chosenCategory.code : '';

    this.checkedImgs = this.checkedImgs.map( r => ({ 'id': r }) );

    this.reportsData.attributes['description'] = [description];
    this.reportsData.attributes['solution'] = [this.reportsData.solution];
    this.reportsData.attributes['transportMode'] = [transportMode];
    this.reportsData.attributes['category'] = [category];
    this.reportsData.attributes['image'] = this.checkedImgs;

    const data = {
      'attributes': this.reportsData.attributes,
      'scheme': 'ticket'
    };

    this.reportService.mergeMultiple(this.reportsData.ids, data).subscribe(res => {
      this.isMerging = false;
      const infoModal = this.modalService.open(InfoModalComponent);
      infoModal.componentInstance.data = {
        header: 'Success',
        text: 'Tickets are merged!'
      };
      infoModal.result.then(() => this.activeModal.close());
    });
  }

  trackByFn(index: any, item: any) {
    return index;
  }

}
